import React from 'react'
import PropTypes from 'prop-types'

// material ui
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardMedia from '@mui/material/CardMedia'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Avatar from '@mui/material/Avatar'

// shared components
import RoomMeetingSchedule from 'components/virtual/shared/RoomMeetingSchedule'

// local components
import PlaceholderAvatar from './PlaceholderAvatar'
import Modal from './Modal'

// containers

const RoomMeetingCard = props => {
  const {
    actions, // via parent
    roomMeeting, // via withQuery
    liveNow, // via withState
    pendingNow, // via withState
    onClickCard // via withEventHandlers
  } = props

  if (!liveNow && !pendingNow) {
    return null
  }

  const { room, meetingHost } = roomMeeting
  const { title, summary, thumbnailUrl, minAge, maxAge } = room
  const { firstName, smallPhotoUrl } = meetingHost || {}

  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Card>
        <CardActionArea onClick={onClickCard}>
          <CardMedia
            image={thumbnailUrl}
            title={title}
            sx={{
              height: '140px'
            }}
          />
          <CardContent>
            <Box mb={1} display='flex' width='100%'>
              <Box flexShrink={1} alignItems='center'>
                {smallPhotoUrl ? (
                  <Avatar
                    variant='square'
                    src={smallPhotoUrl}
                    sx={{
                      mt: 0.5,
                      mx: 'auto',
                      mb: 1,
                      width: '60px',
                      height: '60px',
                      alignItems: 'center'
                    }}
                  />
                ) : (
                  <PlaceholderAvatar />
                )}
                <Typography
                  display='block'
                  variant='caption'
                  align='center'
                  lineHeight={1}
                >
                  {firstName}
                </Typography>
              </Box>
              <Box ml={2} width='100%'>
                <Typography variant='h4'>{title}</Typography>
                <Box mt={0.5}>
                  <RoomMeetingSchedule
                    key={roomMeeting.id}
                    roomMeeting={roomMeeting}
                    liveNow={liveNow}
                  />
                </Box>
              </Box>
            </Box>
            <Typography variant='body2' color='textSecondary' component='p'>
              {summary}
              {minAge && ` Ages ${minAge}—${maxAge}.`}
            </Typography>
          </CardContent>
        </CardActionArea>
        <Modal roomMeeting={roomMeeting} liveNow={liveNow} actions={actions} />
      </Card>
    </Grid>
  )
}

RoomMeetingCard.propTypes = {
  onClickCard: PropTypes.func.isRequired
}

export default RoomMeetingCard
